import {
  dateValueGetter,
  formatLongPrice,
  formatNumber,
  getPureNumber,
  getValueBgClass,
  headerInfoTooltipDef,
  transformPercentageValue,
} from '../../lib/utils';
import { DateTime } from 'luxon';
import { ColDef } from 'ag-grid-community';

export const Earnings = [
  {
    cellClass: 'ticker-cell',
    cellStyle: { fontWeight: 'bold' },
    field: 'date',
    headerName: 'Date',
    valueFormatter: ({ value }: any) => {
      try {
        return DateTime.fromISO(value).toFormat('MM/dd/yyyy');
      } catch (e: any) {
        return '';
      }
    },
    valueGetter: ({ data }: any) => {
      return dateValueGetter(data.date);
    },
    width: 100,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellRendererParams: {
      tickerLogoVisible: true,
    },
    cellStyle: { fontWeight: 'bold' },
    field: 'ticker',
    width: 90,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellStyle: { fontWeight: 'bold' },
    field: 'name',
    width: 200,
  },
  {
    cellClass: 'ticker-cell',
    field: 'eps',
    headerName: 'Actual EPS',
    valueFormatter: ({ value }: any) => formatLongPrice(value),
    valueGetter: ({ data }: any) => getPureNumber(data.eps),
    width: 110,
  },
  {
    field: 'eps_surprise_percent',
    headerName: 'EPS Surprise',
    ...headerInfoTooltipDef('Earnings Per Share (EPS) Surprise.'),
    cellClass: ({ value }: any) => getValueBgClass(value),
    cellStyle: { textAlign: 'left' },
    valueFormatter: ({ value }: any) => formatNumber(value, '%'),
    valueGetter: ({ data }) => transformPercentageValue(data.eps_surprise_percent),
    width: 120,
  },
  {
    cellClass: 'ticker-cell',
    field: 'revenue',
    headerName: 'Actual Rev',
    valueFormatter: ({ value }: any) => formatLongPrice(value),
    valueGetter: ({ data }: any) => getPureNumber(data.revenue),
    width: 110,
  },
  {
    field: 'revenue_surprise_percent',
    headerName: 'Rev Surprise',
    ...headerInfoTooltipDef('Revenue Surprise.'),
    cellClass: ({ value }: any) => getValueBgClass(value),
    cellStyle: { textAlign: 'left' },
    valueFormatter: ({ value }: any) => formatNumber(value, '%'),
    valueGetter: ({ data }: any) => transformPercentageValue(data.revenue_surprise_percent),
    width: 110,
  },
] as ColDef[];
